import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    }]
  },
  {
    path: '/role',
    component: () => import('@/views/role/index'),
    hidden: true
  }
]

export const asyncRouterMap = [
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: { title: '订单', icon: 'order' },
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: { title: '订单列表', icon: 'product-list' }
      },
      {
        path: 'refund',
        name: 'refund',
        component: () => import('@/views/oms/refund/index'),
        meta: { title: '退款列表', icon: 'refund' }
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: { title: '订单详情' },
        hidden: true
      },
      {
        path: 'order_detail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/order_detail'),
        meta: { title: '订单详情' },
        hidden: true
      },
      {
        path: 'refund_detail',
        name: 'refundDetail',
        component: () => import('@/views/oms/refund/refund_detail'),
        meta: { title: '退款详情' },
        hidden: true
      }
    ]
  },
  {
    path: '/statistics',
    component: Layout,
    redirect: '/statistics/index',
    name: 'statistics',
    meta: { title: '订单统计', icon: 'order_statistics' },
    children: [
      {
        path: 'index',
        name: 'classify',
        component: () => import('@/views/oms/order/order_statistics'),
        meta: { title: '应用标签' },
        hidden: true
      }
    ]
  },
  {
    path: '/abc_payment',
    component: Layout,
    redirect: '/abc_payment/index',
    name: 'abc_payment',
    meta: { title: '农行支付', icon: 'order_statistics' },
    children: [
      {
        path: 'merchant_manage',
        name: 'merchant_manage',
        component: () => import('@/views/abc_payment/merchant_manage/index'),
        meta: { title: '商户管理' },
        hidden: true
      },
      {
        path: 'bill_query',
        name: 'bill_query',
        component: () => import('@/views/abc_payment/bill_query/index'),
        meta: { title: '交易查询记录' },
        hidden: true
      }
    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: { title: '权限', icon: 'ums' },
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: { title: '用户列表', icon: 'ums-admin' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: { title: '角色列表', icon: 'ums-role' }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: { title: '分配菜单' },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: { title: '分配资源' },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: { title: '菜单列表', icon: 'ums-menu' }
      },
      {
        path: 'dic',
        name: 'dic',
        component: () => import('@/views/ums/dic/index'),
        meta: { title: '字典列表', icon: 'ums-role' }
      },
      {
        path: 'tags',
        name: 'tags',
        component: () => import('@/views/ums/tags/index'),
        meta: { title: '应用标签', icon: 'ums-tags' }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: { title: '添加菜单' },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: { title: '修改菜单' },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: { title: '资源列表', icon: 'ums-resource' }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: { title: '资源分类' },
        hidden: true
      },
      {
        path: 'app',
        name: 'app',
        component: () => import('@/views/ums/app/index'),
        meta: { title: '应用列表', icon: 'ums-resource' }
      },
      {
        path: 'addApp',
        name: 'addHomeApp',
        component: () => import('@/views/ums/app/add'),
        meta: { title: '添加应用' },
        hidden: true
      },
      {
        path: 'updateApp',
        name: 'updateHomeApp',
        component: () => import('@/views/ums/app/update'),
        meta: { title: '编辑应用' },
        hidden: true
      },
      {
        path: 'appDetail',
        name: 'appDetail',
        component: () => import('@/views/ums/app/appDetail'),
        meta: { title: '应用详情' },
        hidden: true
      },
      {
        path: 'randomMerchants',
        name: 'randomMerchants',
        component: () => import('@/views/ums/randomMerchants/index'),
        meta: { title: '随机商户', icon: 'ums-randomMerchants' }
      },
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js